import Slider_1 from './../img/sliderhome/slider1.jpg'
import Slider_2 from './../img/sliderhome/slider2.jpg'
import Slider_3 from './../img/sliderhome/slider3.jpg'

import Carousel from 'react-bootstrap/Carousel';

export default function SliderHome() {
    return (
        <div className='row'>


            <Carousel interval={3500} nextIcon={false} prevIcon={false} >
                    <Carousel.Item>
                        <img className='d-block w-100' src={Slider_1} alt='First slide' />
                    </Carousel.Item>
                </Carousel>
        </div>
    )
}